const moment = require('moment');
const handlePrintTimeAmPm = time => {
    return moment(time).format('a') === 'pm' ? 'بعد از ظهر' : 'قبل از ظهر';
};

module.exports = handlePrintTimeAmPm;
